import apiClient from './api'; // تأكد من أن اسم الملف صحيح
import { User } from '../types/user'; // استيراد من user.ts

// ==========================================================================
// 1. تعريف أنواع البيانات للنماذج (Types for Forms)
// ==========================================================================

export interface LoginData {
  email: string;
  password: string;
}

// !! تعديل رئيسي: هذا هو الـ payload الجديد الذي يتوقعه الـ backend
export interface RegisterData {
  email: string;
  password: string;
  name: string; // اسم المستخدم مطلوب دائماً
  phone: string;
  registrationType: 'subscriber' | 'trainee' | 'lawyer';
  registrationId?: string; // رقم القيد (اختياري، مطلوب للمحامي والمتدرب)
  
  // حقول إضافية للمشترك فقط
  qualification?: string;
  graduation_year?: number;
}

export interface ChangePasswordData {
  oldPassword: string; // الـ backend يتوقع oldPassword
  newPassword:string;
}

// ==========================================================================
// 2. تعريف أنواع الاستجابات من الـ API (Types for API Responses)
// ==========================================================================

// الـ backend يرسل الآن كائن data يحتوي على user و token
interface LoginApiResponse {
  success: boolean;
  data: {
    user: User;
    token: string;
  };
}

// الـ backend يرسل الآن كائن data يحتوي على المستخدم الجديد
interface RegisterApiResponse {
  success: boolean;
  message: string;
  data: User;
}

// !! تعديل: واجهة الاستجابة الآن بسيطة جداً !!
interface LoginApiResponse {
  success: boolean;
  message: string;
  user: User;
  token: string;
}
// ==========================================================================
// 3. دوال الخدمة (Service Functions)
// ==========================================================================

/**
 * دالة تسجيل الدخول
 * @param data - البريد الإلكتروني وكلمة المرور
 * @returns كائن يحتوي على معلومات المستخدم والتوكن
 */
// !! الإصلاح هنا: نحدد نوع الإرجاع ونضيف جملة return !!
export const login = async (data: LoginData): Promise<{ user: User; token: string }> => {
  const response = await apiClient.post<LoginApiResponse>('/auth/login', data);

  // !! الإصلاح النهائي الحقيقي !!
  // البيانات التي نريدها موجودة مباشرة في response.data
  console.log('📦 [SERVICE] Final correct data to be returned:', response.data);
  
  // نحن نرجع الكائن بأكمله لأنه يطابق ما تعد به الدالة
  return response.data; 
};
/**
 * دالة تسجيل مستخدم جديد
 * @param data - بيانات التسجيل الكاملة
 * @returns معلومات المستخدم الجديد الذي تم إنشاؤه
 */
export const register = async (data: RegisterData): Promise<User> => {
  const response = await apiClient.post<RegisterApiResponse>('/auth/register', data);
  // !! تعديل: الوصول إلى البيانات داخل كائن data
  return response.data.data;
};

/**
 * دالة تغيير كلمة المرور
 * @param data - كلمة المرور الحالية والجديدة
 */
export const changePassword = async (data: ChangePasswordData): Promise<void> => {
  // هذا المسار محمي، و apiClient سيرسل التوكن تلقائياً
  await apiClient.post('/auth/change-password', data);
};
